export default __webpack_public_path__ + "static/media/Email.e9dc3f7b.svg";